// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1tTmj","footer":"ModalInfo_footer__1or-k"};